import { faTag, faStickyNote } from "@fortawesome/free-solid-svg-icons";
import createField from "../../../utils/factory/createField";

export const typeFields = [
  {
    section: "Dados do Tipo",
    fields: [
      createField({
        id: "type.name",
        label: "Tipo",
        type: "text",
        placeholder: "Digite o nome do tipo",
        icon: faTag,
      }),
      createField({
        id: "type.is_kit",
        label: "É kit?",
        type: "select",
        placeholder: "Selecione se esse tipo é kit ou nao",
        icon: faStickyNote,
      }),
    ],
  },
];
